import React, { FC } from 'react';
import cn from 'classnames';

type Props = {
  clickable?: boolean;
  onClick?: () => void;
  hasLabel?: boolean;
  adminPage?: boolean;
};

const OfferIconWrapper: FC<Props> = ({
  children,
  onClick,
  adminPage,
  hasLabel,
}) => (
  <div
    onClick={onClick}
    className={cn(
      'Offer-Icon-Wrapper',
      'relative pr-15',
      hasLabel && 'md:pt-28',
      adminPage
        ? 'cursor-default Offer-Icon-Wrapper--disabled'
        : 'cursor-pointer',
    )}
  >
    {children}
    <span
      className={cn(
        'h-10 -left-15 pointer-events-none hidden absolute w-20 border-b md:inline-block rounded-bl-sm top-half',
        { 'transform -translate-y-10 Tree__line--horizontal': !adminPage },
        { 'Tree__line--admin': adminPage },
      )}
    />
  </div>
);

export default OfferIconWrapper;
